import React from 'react'
import {
  ThemeProvider,
  ModalProvider,
  straitsXTheme,
  AntdConfigProvider,
} from '@xfers/design-system'

export default ({ children }: { children: React.ReactNode }) => {
  return (
    <AntdConfigProvider>
      <ThemeProvider theme={straitsXTheme}>
        <ModalProvider>{children}</ModalProvider>
      </ThemeProvider>
    </AntdConfigProvider>
  )
}
